const progressReducer = (state = 0, action) => {
  switch (action.type) {
    case 'PROGRESSION':
      return action.data
    default:
      return state
  }
}

export default progressReducer
